import { gql } from "@apollo/client";

export const GET_COMBO_VISITA_VALOR = gql`
query GetComboVisitaValoresById($idComboVisita: Int!) {
    comboVisitaValoresById(idComboVisita: $idComboVisita) {
        idComboVisitaValor
        valor
    }
}`;

export default GET_COMBO_VISITA_VALOR;

const adaptComboVisita = (combo) => ({ id: combo.idComboVisitaValor, displayName: combo.valor });

export const adaptCombosVisitas = (data) => {
  return structuredClone(data?.comboVisitaValoresById).
  map((combo) => adaptComboVisita(combo));
};